<template>
  <div class="listmain ">
      <h1 class="firTitle">OrionServiceSDK 接入</h1>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
         各个 Framework 都支持 Debug、Release、真机、模拟器。<br>
以下脚本作用是删除支持模拟器的架构，为了 AppStore 打包时去掉Debug信息。
          </span>
      </p>

      <highlight-code lang="javascript">
         <span>
             if [ "${CONFIGURATION}" = "Release" ]; then
APP_PATH="${TARGET_BUILD_DIR}/${WRAPPER_NAME}"

# This script loops through the frameworks embedded in the application and
# removes unused architectures.
find "$APP_PATH" -name '*.framework' -type d | while read -r FRAMEWORK
do
FRAMEWORK_EXECUTABLE_NAME=$(defaults read "$FRAMEWORK/Info.plist" CFBundleExecutable)
FRAMEWORK_EXECUTABLE_PATH="$FRAMEWORK/$FRAMEWORK_EXECUTABLE_NAME"
echo "Executable is $FRAMEWORK_EXECUTABLE_PATH"

EXTRACTED_ARCHS=()

for ARCH in $ARCHS
do
echo "Extracting $ARCH from $FRAMEWORK_EXECUTABLE_NAME"
lipo -extract "$ARCH" "$FRAMEWORK_EXECUTABLE_PATH" -o "$FRAMEWORK_EXECUTABLE_PATH-$ARCH"
EXTRACTED_ARCHS+=("$FRAMEWORK_EXECUTABLE_PATH-$ARCH")
done

echo "Merging extracted architectures: ${ARCHS}"
lipo -o "$FRAMEWORK_EXECUTABLE_PATH-merged" -create "${EXTRACTED_ARCHS[@]}"
rm "${EXTRACTED_ARCHS[@]}"

echo "Replacing original executable with thinned version"
rm "$FRAMEWORK_EXECUTABLE_PATH"
mv "$FRAMEWORK_EXECUTABLE_PATH-merged" "$FRAMEWORK_EXECUTABLE_PATH"

done
fi
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
        加入脚本位置如下：
          </span>
      </p>
      <img src="../../../../../static/images/sdk/script.png" alt="脚本">
      <h3 class="sedTitle">OrionServiceSDK 及其相关组件的导入</h3>
      <img src="../../../../../static/images/sdk/imp.png" alt="导入">
    <p>系统会自动加入到 linked Frameworks and Libraries 中。 </p>
      <h3 class="sedTitle">注册</h3>
      <p>注册猎户OS 服务需要提前申请相关ClientID、ClientSecret，通过registerWithUClientID 接口传入申请好的ClientID等信息启动猎户OS服务；

          <highlight-code lang="javascript">
             <span>
                 - (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    // 填写用户中心 UClientID 、用户中心 uClientSecret；
    // 填写 语音服务 ClientID 、ClientSecret；
    [[OrionSDK shared] registerWithUClientID:@"orion.ucenter.e0e1dbc5c2ede64d"
                               uClientSecret:@"a5bfdc51078143f8a73fee2ae6d76b4a"
                                 ovsClientID:@"orion.ovs.client.1503470121484"
                             ovsClientSecret:@"BEBFDEBBC67A35E102945BBAEFC52914"];
    // 需要实现相关代理；
    [OrionSDK shared].dataSource = self;
    [OrionSDK shared].delegate = self;
    [OrionSDK shared].configDataSource = self;

    if ([OVSUserModel sharedInstance].isLogin) {
        // after login
        APIListTableViewController *apilist = [[APIListTableViewController alloc] init];
        OVSBaseNavigationController *navigationController = [[OVSBaseNavigationController alloc] initWithRootViewController:apilist];
        [UIApplication sharedApplication].delegate.window.rootViewController = navigationController;
    } else {
        UIStoryboard *storyBoard = [UIStoryboard storyboardWithName:@"Main" bundle:nil];
        UIViewController *login = [storyBoard instantiateViewControllerWithIdentifier:@"login"];
        OVSBaseNavigationController *navigationController = [[OVSBaseNavigationController alloc] initWithRootViewController:login];
        [UIApplication sharedApplication].delegate.window.rootViewController = navigationController;
    }

    return YES;
}
             </span>
    </highlight-code>
     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Imp_register.vue